$(function () {
    $('[data-map-simple]').each(function () {
        var geolocation = this.dataset.mapSimple.split(';');
        init(this, geolocation);
    });

    function init(el, geolocation) {
        var defaultLatLng = { lat: 41.551029, lng: -8.428204 };
        if (geolocation.length < 2) {
            geolocation = ['41.551029', '-8.428204', '10'];
        }
        var defaultLatLng = { lat: parseFloat(geolocation[0]), lng:  parseFloat(geolocation[1]) };
        var map = new google.maps.Map(el, {
            center: defaultLatLng,
            zoom: 14,
            disableDefaultUI: true
        });
        map.setOptions({ draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true });

        // if ("geolocation" in navigator) {
        //     navigator.geolocation.getCurrentPosition(function (position) {
        //         map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
        //         map.setZoom(15);

        //         setRadius(map, { lat: position.coords.latitude, lng: position.coords.longitude });
        //     });
        // } else {
        //     setRadius(map, defaultLatLng);
        // }

        setRadius(map, defaultLatLng, parseInt(geolocation[2]), geolocation[3]);

        // var bounds = new google.maps.LatLngBounds();
        // bounds.extend(defaultLatLng);
        // map.fitBounds(bounds);

        // setTimeout(function () {
        //     map.setZoom(map.zoom - 5);
        // }, 500);
        var center = { lat: parseFloat(geolocation[0]), lng: parseFloat(geolocation[1]) };
        map.fitBounds(new google.maps.LatLngBounds(center, center), { top: 50, left: 50, right: 50, bottom: 50});
        setTimeout(function () {
            if (geolocation[3] == 'wifi') {
                map.setZoom(map.getZoom() - 6);
            } else if (location.src == 'lbs') {
                map.setZoom(map.getZoom() - 8);
            } else {
                map.setZoom(map.getZoom() - 4);
            }
        }, 500);
    }

    function setRadius(map, position, radius, src) {
        var colorPointFill = "#4caf50"
        if (src == 'wifi') {
            colorPointFill = '#ffc107';
        } else if (src == 'lbs') {
            colorPointFill = '#f44336';
        }

        var pointCircle = new google.maps.Marker({
            position: position,
            map: map,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                strokeColor: colorPointFill,
                strokeOpacity: 1,
                strokeWeight: 1,
                fillColor: colorPointFill,
                fillOpacity: 1,
                scale: 8 //pixels
            }
        });

        var radiusCircle = new google.maps.Circle({
            strokeColor: colorPointFill,
            strokeOpacity: 0.5,
            strokeWeight: 0.5,
            fillColor: colorPointFill,
            fillOpacity: 0.5,
            map: map,
            center: position,
            radius: radius
        });
    }
});